import { makeStyles } from "@mui/styles";
import { COLORS } from "components/v3/Theme/colors";

const LinkBoxGridStyles = makeStyles((theme) => ({
  container: {
    padding: "10px 20px 1rem"
  },
  linkBoxContainer: {
    display: "flex"
  },
  linkBox: {
    borderBottom: `1px solid ${COLORS.GRAY}`,
    width: "95%",
    paddingBottom: "1rem",
    marginBottom: "1rem",
    lineHeight: "1.5rem"
  },
  summary: {
    color: COLORS.BLACK,
    fontWeight: 400,
    display: "block",
    fontSize: "1rem",
    lineHeight: "1.5rem"
  }
}));

export default LinkBoxGridStyles;
